<template>
  <div class="all-question-outer">
    <div class="sign" v-if="questionData.data.is_sign == '1'">
      <img src="../../../../assets/cancelSign.png" alt="" />

      <span>已标记</span>
    </div>
    <div class="question" v-if="questionData.data.content">
      <div class="questionTop">
        <div class="title">
          「多选题」
          <span class="score" v-if="questionData.data.score"
            >{{ questionData.data.score }}分</span
          >
          <span class="getScore" v-if="questionData.record_id">
            得分:{{
              questionData.data.user_log.score
                ? questionData.data.user_log.score
                : 0
            }}分
          </span>
        </div>
        <!-- 试题附件展示组件 -->
        <question-files
          v-if="questionData.data.attachment"
          :attachment="questionData.data.attachment"
        ></question-files>
        <!-- questionData.index+1 -->
        <span class="questionName"
          >{{ questionData.data.num }}、<span
            v-html="questionData.data.content"
          ></span
        ></span>
      </div>
      <ul class="checkboxContent">
        <a-checkbox-group v-model="valueList" disabled class="selete">
          <li v-for="(item, index) in questionData.data.items" :key="item.id">
            <a-checkbox :value="item.id">
              {{ String.fromCharCode(index + 65) }}、<span
                v-html="item.content"
              ></span>
            </a-checkbox>
          </li>
        </a-checkbox-group>
      </ul>
      <div
        :class="
          questionData.data.user_log.is_right == '1' ? 'answer1' : 'answer2'
        "
      >
        <span>正确答案：{{ right }}</span>
        <span
          >你的答案：{{ questionData.data.user_log ? myAnswer : "未答" }}</span
        >
      </div>
      <div class="ansAnalysis">
        答案解析：
        <div
          v-html="
            questionData.data.correct_content
              ? questionData.data.correct_content
              : '无'
          "
        ></div>
      </div>
    </div>
    <div class="question" v-else>
      <div class="questionTop">
        <span class="deleted">{{ questionData.data.num }}、此题已被删除</span>
      </div>
      <div class="deleteImg">
        <img src="@/assets/deleted.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import QuestionFiles from "../questionFiles.vue";
export default {
  name: "checkbox",
  props: ["questionData"],
  components: { QuestionFiles },
  data() {
    return {
      valueList: [],
      right: "",
      myAnswer: "",
    };
  },
  created() {
    let arr2 = [];
    if (this.questionData.data && this.questionData.data.user_log && this.questionData.data.user_log.answer) {
      let answer = this.questionData.data.user_log.answer.split(",");
      answer && answer.forEach((element) => {
          this.valueList.push(Number(element));
        });
    }
    this.questionData.data && this.questionData.data.items && this.questionData.data.items.forEach(function (item, index) {
      if (item.is_right == "1") {
        arr2.push(String.fromCharCode(index + 65));
      }
    });
    this.right = arr2.join();
    if (this.questionData.data && this.questionData.data.user_log && this.questionData.data.user_log.answer) {
      let arr1 = [];
      let that = this;
      if (that.questionData.data.user_log) {
        that.questionData.data.items.forEach(function (item, index) {
          if (that.questionData.data.user_log.answer) {
            let arr3 = that.questionData.data.user_log.answer.split(",");
            arr3.forEach(function (obj) {
              if (item.id == obj) {
                arr1.push(String.fromCharCode(index + 65));
              }
            });
          }
        });
      }
      this.myAnswer = arr1.join();
    } else {
      this.myAnswer = "无";
    }
  },
};
</script>

<style lang="less" scoped>
.all-question-outer {
  width: 100%;
  height: calc(100% - 60px);
  padding: 20px 50px 30px 50px;
  position: relative;
}
.sign {
  height: 32px;
  text-align: right;
  color: #f79e3f;
  position: absolute;
  top: 35px;
  right: 50px;
}
.sign img {
  width: 30px;
  height: auto;
  margin-right: 4px;
  display: inline-block;
}
.sign span {
  line-height: 32px;
}
.question .title {
  width: 371px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 32px;
}
.question .questionName {
  width: 92px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #14202c;
  line-height: 32px;
  word-wrap: break-word;
  word-break: normal;
}
.questionTop {
  padding: 15px 0 0;
  /deep/img {
    display: block;
    max-width: 100%;
  }
  /deep/p:first-child {
    display: inline;
  }
  /deep/ol {
    list-style: decimal;
    margin-left: 15px;
  }
}
li {
  margin-bottom: 10px;
  height: auto;
}
li img {
  display: block;
  height: 110px;
  width: 80%;
  margin-top: 10px;
}
.answer1 {
  height: 40px;
  background: #d7f3ea;
  margin-top: 15px;
  /deep/img {
    display: block;
    max-width: 100% !important;
  }
}
.answer2 {
  height: 40px;
  background: #fae7e6;
  margin-top: 15px;
  /deep/img {
    display: block;
    max-width: 100% !important;
  }
}
.answer1 span {
  width: 79px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #32b387;
  line-height: 40px;
  margin-left: 18px;
  margin-right: 10px;
}
.answer2 span {
  width: 79px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ea7e7b;
  line-height: 40px;
  margin-left: 18px;
  margin-right: 10px;
}
.ansAnalysis {
  margin-top: 21px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
  word-break: break-all;
  margin-bottom: 40px;
  /deep/img {
    display: block;
    max-width: 100% !important;
  }
}
/deep/.selete ul,
/deep/.selete ol {
  display: inline-block;
}
/deep/.selete {
  word-wrap: break-word;
  word-break: normal;
}
/deep/.ansAnalysis ul,
/deep/.ansAnalysis ol {
  list-style: decimal;
  margin-left: 15px;
}
/deep/.checkboxContent img,
/deep/.ansAnalysis img {
  max-width: 90% !important;
  display: block;
  margin-top: 5px;
}
/deep/.checkboxContent p {
  display: inline;
}
.score {
  color: #9a3bec;
  font-weight: normal;
}
.deleted {
  color: #ea7e7b;
  font-size: 16px;
}
.deleteImg {
  text-align: center;
  height: 475px;
  margin-top: 140px;
}
.getScore {
  margin-left: 50px;
  font-weight: normal;
}
</style>
<style>
.question .ant-checkbox-group .ant-checkbox-disabled + span {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #14202c;
  line-height: 32px;
}
.question .ant-checkbox-group .ant-checkbox-disabled .ant-checkbox-inner {
  background-color: #fff;
}
/* .question .ant-checkbox-group .ant-checkbox-checked .ant-checkbox-inner{
    border-color: #19BE94 !important;
}
.question .ant-checkbox-group .ant-checkbox-disabled .ant-checkbox-inner::after {
    border-color: #19BE94;
} */
</style>